import { makeReducer } from '../../core/make-reducer';
import { makeActionCreators } from '../../core/make-action-creators';
import * as API from '../../core/api';
import User from '../class';

export const actions = {
  REQUEST: 'Dora/all-users/REQUEST',
  RECEIVE: 'Dora/all-users/SUCCESS',
  FAIL: 'Dora/all-users/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'users',
  actions,
  requestDataCall: (store, params) =>
    API.get('users', params).then((res) => res.map((u) => new User(u))),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/user/users/duck.js